export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6244.9e238160.jpg";